import React, { FC, SVGProps } from 'react'

const ListIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg fill="none" viewBox="0 0 48 48" {...props}>
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      stroke="white"
      strokeWidth="4"
    />
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fill="#E8ECEF"
    />
    <path
      d="M24.07 11.72C21.7307 11.722 19.4445 12.4175 17.5003 13.7186C15.5562 15.0197 14.0415 16.868 13.1476 19.0298C12.2538 21.1916 12.0209 23.5699 12.4785 25.864C12.9361 28.1582 14.0636 30.2651 15.7185 31.9186C17.3733 33.5721 19.4812 34.6978 21.7758 35.1534C24.0703 35.6091 26.4484 35.3742 28.6095 34.4785C30.7705 33.5829 32.6175 32.0666 33.917 30.1214C35.2164 28.1761 35.91 25.8893 35.91 23.55C35.9113 21.9952 35.6059 20.4555 35.0112 19.019C34.4166 17.5825 33.5443 16.2774 32.4445 15.1784C31.3446 14.0795 30.0388 13.2084 28.6018 12.6149C27.1647 12.0215 25.6248 11.7174 24.07 11.72V11.72ZM24.07 33.01C22.199 33.01 20.37 32.4552 18.8143 31.4157C17.2586 30.3762 16.0461 28.8988 15.3301 27.1702C14.6141 25.4416 14.4268 23.5395 14.7918 21.7044C15.1568 19.8694 16.0578 18.1838 17.3808 16.8608C18.7038 15.5378 20.3894 14.6368 22.2245 14.2718C24.0595 13.9068 25.9616 14.0941 27.6902 14.8101C29.4188 15.5261 30.8962 16.7386 31.9357 18.2943C32.9752 19.85 33.53 21.679 33.53 23.55C33.5274 26.0538 32.5323 28.4543 30.7628 30.2257C28.9933 31.9971 26.5938 32.9947 24.09 33L24.07 33.01Z"
      fill="#5A6169"
      fillOpacity="0.75"
    />
    <path
      d="M24.68 17.64H22.9V24.73L29.11 28.45L30 27L24.68 23.84V17.64Z"
      fill="#5A6169"
      fillOpacity="0.75"
    />
  </svg>
)

export default ListIcon
